import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit, OnChanges } from '@angular/core';

import { ApiService } from '@services/api.service';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LocalizationService } from '@services/localization.service';
import { environment } from '@environments/environment';
import { UiHelper } from '@helpers/ui.helper';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IdleDialog } from '../dialogs/idle.dialog';

@Component({
  selector: 'casino-component',
  templateUrl: '../sharedTemplates/livecasino.component.html',
})
export class LiveCasinoComponent implements OnChanges {
  gameTypes = [];

  selectedGameType;
  gameNameByID = {
    1: 'Roulette',
    2: 'Blackjack',
    4: 'Baccarat',
    8: 'Texas hold’em Bonus',
    12: 'Dragon Tiger',
    16: 'Sic-Bo',
    22: 'Wheel Of Fortune',
    24: 'Andar Bahar',
  };
  casinoList;

  constructor(private _ApiService: ApiService, public _UserHelper: UserHelper, public _LocalizationService: LocalizationService, public _MatDialog: MatDialog) {}

  ngOnInit() {
    const translator = new TranslatePipe(this._LocalizationService);
    this.selectedGameType = translator.transform('all', null);
    this.getCasinoList();
  }

  ngOnChanges(): void {
    this.getCasinoList();
  }

  getCasinoList() {
    const translator = new TranslatePipe(this._LocalizationService);

    this._ApiService.getLiveCasinoGames().then(x => {
      if (x) {
        this.gameTypes = [];
        this.gameTypes.push(translator.transform('all', null));
        //////console.log("Live Casino X :", x);

        x.forEach(item => this.gameTypes.push(item.company));
        this.gameTypes = [...new Set(this.gameTypes)];
        this.casinoList = this.gameTypes[0] === this.selectedGameType ? x.filter(item => item.company) : x;
      }
    });
  }

  handleGameTypeChange(e) {
    this.selectedGameType = e;
    this.getCasinoList();
  }

  openGame(item) {
    // let windowReference = window.open();
    this._ApiService.openLiveCasinoGame(item.company, item.gameID, item.limitId).then(res => {
      decodeURI(res);

      const mobileAppend = environment.mobile ? '&platform=mobile' : '';
      const _url = item.connectionUrl.split('languageID={1}')[0] + decodeURI(res) + mobileAppend;
      //  window.open(item.connectionUrl.split('languageID={1}')[0] + decodeURI(res) + mobileAppend, "MyWindow", item.winParams);
      this.idleDialogOpener(true, _url);
      //  windowReference.location.href = item.connectionUrl.split('languageID={1}')[0] + decodeURI(res) + mobileAppend;
    });
  }

  idleDialogOpener(x, url) {
    const dialogRef = this._MatDialog;
    if (x) {
      dialogRef.closeAll();

      dialogRef
        .open(goToCasinoDialog, {
          width: '350px',
          minHeight: '25vh',
          panelClass: 'idle-dialog',
          data: url,
        })
        .afterClosed()
        .subscribe(result => {
          ////console.log('The dialog was closed' + result);
        });
    } else {
      dialogRef.closeAll();
    }
  }
}

@Component({
  selector: 'goto-casino',
  templateUrl: '../sharedTemplates/gotocasino.dialog.html',
})
export class goToCasinoDialog {
  __url;

  constructor(public dialogRef: MatDialogRef<goToCasinoDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
    ////console.log(this.data);
    this.__url = this.data;
  }

  closeD() {
    this.dialogRef.close();
  }
}
